module.exports = __webpack_public_path__ + "static/assets/465a1a16d4e21659274289aeac60aac7.png";